import { GlButton, GlButtonGroup, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { isGid, getIdFromGraphQLId } from '~/graphql_shared/utils';
import Tracking from '/builds/gitlab/gitlab-ee/app/assets/javascripts/tracking/index.js?vue3';
import { BUTTON_TOOLTIP_RETRY, BUTTON_TOOLTIP_CANCEL, TRACKING_CATEGORIES } from '~/ci/constants';
import PipelineMultiActions from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/pipelines_page/components/pipeline_multi_actions.vue?vue3';
import PipelinesManualActions from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/pipelines_page/components/pipelines_manual_actions.vue?vue3';
import PipelineStopModal from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/pipelines_page/components/pipeline_stop_modal.vue?vue3';
export default {
    name: 'PipelineOperations',
    BUTTON_TOOLTIP_RETRY,
    BUTTON_TOOLTIP_CANCEL,
    directives: {
        GlTooltip: GlTooltipDirective
    },
    components: {
        GlButton,
        GlButtonGroup,
        PipelineMultiActions,
        PipelinesManualActions,
        PipelineStopModal
    },
    mixins: [
        Tracking.mixin()
    ],
    props: {
        pipeline: {
            type: Object,
            required: true
        }
    },
    emits: [
        'cancel-pipeline',
        'job-action-executed',
        'retry-pipeline'
    ],
    data () {
        return {
            isCanceling: false,
            isRetrying: false,
            showConfirmationModal: false,
            pipelineToCancel: this.pipeline
        };
    },
    computed: {
        fullPath () {
            return this.pipeline?.project?.fullPath || this.pipeline?.project?.full_path.slice(1);
        },
        hasActions () {
            const hasRESTActions = this.pipeline?.details?.has_manual_actions || this.pipeline?.details?.has_scheduled_actions;
            const hasGraphQLActions = this.pipeline?.hasManualActions || this.pipeline?.hasScheduledActions;
            return hasRESTActions || hasGraphQLActions;
        },
        isRetryable () {
            // REST flags already include the permission check server-side
            const isRESTRetryable = this.pipeline?.flags?.retryable;
            const isGraphQLRetryable = this.pipeline?.retryable && this.pipeline?.userPermissions?.updatePipeline;
            return isRESTRetryable || isGraphQLRetryable;
        },
        isCancelable () {
            const isRESTCancelable = this.pipeline?.flags?.cancelable;
            const isGraphQLCancelable = this.pipeline?.cancelable && this.pipeline?.userPermissions?.cancelPipeline;
            return isRESTCancelable || isGraphQLCancelable;
        },
        pipelineId () {
            if (isGid(this.pipeline.id)) {
                return getIdFromGraphQLId(this.pipeline.id);
            }
            return this.pipeline.id;
        },
        modalPipeline () {
            const pipeline = this.pipelineToCancel;
            // The modal reads GraphQL field names, so REST rows are adapted below.
            // Both branches go away once `mr_pipelines_graphql` ships and the REST table is removed.
            if (isGid(pipeline.id)) {
                return pipeline;
            }
            return {
                ...pipeline,
                ref: pipeline.ref?.name,
                refUrl: pipeline.ref?.path,
                commit: pipeline.commit && {
                    ...pipeline.commit,
                    shortId: pipeline.commit.short_id,
                    webPath: pipeline.commit.commit_path
                },
                detailedStatus: pipeline.details?.status
            };
        },
        pipelineIid () {
            // GraphQL returns a string, pipeline manual actions expects a number
            return Number(this.pipeline.iid);
        }
    },
    watch: {
        pipeline () {
            if (this.isCanceling || this.isRetrying) {
                this.isCanceling = false;
                this.isRetrying = false;
            }
        }
    },
    methods: {
        onCloseModal () {
            this.showConfirmationModal = false;
        },
        onConfirmCancelPipeline () {
            this.isCanceling = true;
            this.showConfirmationModal = false;
            this.$emit('cancel-pipeline', this.pipelineToCancel);
        },
        handleCancelClick () {
            this.showConfirmationModal = true;
            this.pipelineToCancel = this.pipeline;
            this.trackClick('click_cancel_button');
        },
        handleRetryClick () {
            this.isRetrying = true;
            this.trackClick('click_retry_button');
            this.$emit('retry-pipeline', this.pipeline);
        },
        onManualJobPlayed () {
            this.$emit('job-action-executed', this.pipeline);
        },
        trackClick (action) {
            this.track(action, {
                label: TRACKING_CATEGORIES.table
            });
        }
    }
};
